/**
 * FullStacked Cloud Console - Top bar plan chip (BASE / PRO, with an amber dot from 80% and a red
 * dot at 100% of any meter) linking to Settings → Plan & billing, and the Invitations count
 * (console.md §7.A, "Top Navigation Bar").
 */

import { useApp } from "../app-context.ts";
import { worstTone } from "../lib/billing.ts";

export function PlanChip() {
    const { billing, navigate } = useApp();
    if (!billing) return null;
    const pro = billing.plan === "pro";
    const tone = worstTone(billing);
    const title =
        tone === "danger"
            ? "A Base plan limit is reached"
            : tone === "warning"
              ? "You use 80% or more of a Base plan limit"
              : "Plan & billing";
    return (
        <button
            className={`badge plan-chip ${pro ? "badge-brand" : "badge-neutral"}`}
            title={title}
            onClick={() => navigate({ view: "settings", tab: "billing" })}
        >
            {billing.planNames[billing.plan]}
            {tone !== "neutral" ? <span className={`dot dot-${tone}`} aria-label={title} /> : null}
        </button>
    );
}

export function InvitationsLink() {
    const { billing, navigate } = useApp();
    const count = billing?.pendingInvitations ?? 0;
    return (
        <button
            className="btn btn-ghost btn-sm"
            onClick={() => navigate({ view: "invitations" })}
            title={count ? `${count} invitation(s) waiting for you` : "Invitations"}
        >
            Invitations
            {count ? <span className="count-badge">{count}</span> : null}
        </button>
    );
}
